import { ClarityType } from '../constants';
export function listCV(values) {
    return { type: ClarityType.List, value: values };
}
//# sourceMappingURL=listCV.js.map